export default {"src":"https://images-cdn-staging.curipod.com/d-a8388eb7/_next/static/media/emojiBackground1.c6354451.svg","height":257,"width":356};